import { render, staticRenderFns } from "./ModalNiveisVendedor.vue?vue&type=template&id=1079da2a&scoped=true"
import script from "./ModalNiveisVendedor.vue?vue&type=script&lang=ts"
export * from "./ModalNiveisVendedor.vue?vue&type=script&lang=ts"
import style0 from "./ModalNiveisVendedor.vue?vue&type=style&index=0&id=1079da2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079da2a",
  null
  
)

export default component.exports